export default __webpack_public_path__ + "static/media/tube-1-h-en.9b7a094a.svg";